import { get, head, isEmpty, pick, size } from 'lodash/fp';
import React from 'react';

import CalloutSection from '../../../../../components/sections/callout-section';
import FeaturesSection from '../../../../../components/sections/features-section';
import getValuePropositionData from '../../utils/get-value-propositon-data';

type ValuePropositionsSectionProps = {
  valuePropositions?: {
    title?: string;
    valuePropositionsReference?: {
      image?: {
        alt?: string;
        src?: string;
      };
      summary?: string | unknown[];
      title?: string;
      urlObject?: {
        name?: string;
        url?: string;
      };
    }[];
  };
};

const ValuePropositionsSection = ({ valuePropositions }: ValuePropositionsSectionProps) => {
  const valuePropositionsContent = get('valuePropositionsReference', valuePropositions);

  if (isEmpty(valuePropositionsContent)) {
    return null;
  }

  const tileData = getValuePropositionData(valuePropositionsContent);

  if (size(valuePropositionsContent) > 1) {
    const featureSectionTitle = get('title', valuePropositions);
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'string | undefined' is not assignable to type 'string | Element'.
    return <FeaturesSection tiles={tileData} title={featureSectionTitle} withBorder />;
  }

  const calloutUrlObject = get('urlObject', head(tileData));

  return (
    <CalloutSection
      {...pick(['image', 'summary', 'title'], head(tileData))}
      // @ts-expect-error - Automatic, Please fix when editing this file
      cta={calloutUrlObject ? { title: calloutUrlObject.name, to: calloutUrlObject.url } : null}
      withBorder
    />
  );
};

ValuePropositionsSection.defaultProps = {
  valuePropositions: null,
};

export default ValuePropositionsSection;
